import { UserManager } from 'oidc-client';


const settings = {
  authority: 'https://testauth.pik.ru/',
  client_id: 'directual_spa',
  redirect_uri: 'http://localhost:4200/login',
  response_type: 'code id_token token',
  scope: 'openid profile email',
  filterProtocolClaims: true,
  loadUserInfo: true,
};


export class AuthService {
  constructor(redirectURI) {
    const redirect_uri = redirectURI || settings.redirect_uri;
    // for production auth
    if (process.env.NODE_ENV !== 'development') {
      settings.authority = 'https://auth.pik.ru/';
    }
    this.userManager = new UserManager({ ...settings, redirect_uri });
  }

  getUser = () => this.userManager.getUser();
  loginCallback = () => this.userManager.signinRedirectCallback();
  login = () => this.userManager.signinRedirect();
  renewToken = () => this.userManager.signinSilent();
  logout = () => this.userManager.signoutRedirect();
  clearState = () => this.userManager.clearStaleState();
}



// WEBPACK FOOTER //
// ./src/Auth/oidc/AuthService.js